module.exports = __webpack_public_path__ + "img/101-el-04.prt.e41549af.jpg";